import { useCallback, useMemo } from "react";
import { SidePanelDS } from "@qivia/ui";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { useAppSelector } from "../../../../../redux/hooks";
import { selectManager } from "../../../homeSlice";
import { selectLinkyConsents } from "../../linkyConsentsSlice";
import { SidePanelHeader } from "./sidePanelHeader";
import { DriverDetails } from "./driverDetails";
import { SidePanelSendLink } from "./sidePanelSendLink";
import "../../../../../i18n/i18n";

export const DriverSidePanel = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const firstPath = location.pathname.split("/")[1];
  const linkyConsents = useAppSelector(selectLinkyConsents);
  const manager = useAppSelector(selectManager);

  const isOwnerOrAdmin = useMemo(
    () => manager?.role === "OWNER" || manager?.role === "ADMIN",
    [manager],
  );

  const driver =
    linkyConsents.find((consent) => consent.uuid === params.id) ?? null;

  const onSidePanelClosed = useCallback(() => {
    navigate(`/${firstPath}/electric_charging/linky_connections`);
  }, [firstPath, navigate]);

  if (!driver) {
    return;
  }

  const canResendLink =
    isOwnerOrAdmin &&
    !!driver.consentLinkExpiresAt &&
    driver.consentStatus !== "VALIDATED";

  return (
    <SidePanelDS.SidePanel
      visible={!!driver}
      onClose={onSidePanelClosed}
      absoluteSection={
        canResendLink ? <SidePanelSendLink driver={driver} /> : undefined
      }
    >
      <SidePanelDS.Section
        verticalSpacing={1.5}
        horizontalSpacing={1.5}
        background={colors["colors/button/secondary/hover"]}
      >
        <SidePanelHeader driver={driver} />
      </SidePanelDS.Section>
      <SidePanelDS.Section verticalSpacing={1.5} horizontalSpacing={1.5}>
        <DriverDetails driver={driver} />
      </SidePanelDS.Section>
    </SidePanelDS.SidePanel>
  );
};
